var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnologyIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.75L26.1627 13.1195C26.5055 13.196 26.75 13.4998 26.75 13.8515V21.3417C26.75 22.8462 25.9977 24.2517 24.746 25.0858L20 28.25L15.254 25.0858C14.0015 24.251 13.25 22.8463 13.25 21.3425V13.8515C13.25 13.4998 13.4945 13.196 13.8372 13.1195L20 11.75ZM20 13.2868L14.75 14.453V21.3417C14.75 22.3445 15.251 23.2812 16.0858 23.8378L20 26.4478L23.9142 23.8378C24.749 23.2812 25.25 22.3453 25.25 21.3425V14.453L20 13.2875V13.2868ZM23.339 17.1665L24.4003 18.227L19.6273 23L16.445 19.8177L17.5055 18.7573L19.6265 20.8783L23.339 17.1657V17.1665Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyIcon13);
export default __webpack_public_path__ + "static/media/technology_icon1_3.656882a805186018d26fa78019b73e3c.svg";
export { ForwardRef as ReactComponent };